import React, { useContext } from 'react';
import { Icons, IconButton } from '@nextiva/next-ui-components';
import { formattedLicensePricingDataType } from 'types/purchaseLicenseModalTypes';
import { LicensesContext } from '../../../containers/pages/BillingLicenses/licensesContext/index';
import {
  StyledLicenseAmountContainer,
  StyledBoxIconContainer,
  StyledBoxIcon,
  StyledLicenseNameText,
  StyledQuantityField,
  StyledXText,
  StyledPriceText,
  StyledTrashIcon,
  StyledFlexItem,
} from './LicenseQuantity.styles';

interface ILicenseQuantity {
  quantity: string;
  setQuantity: (quantity: string) => void;
  formattedLicensePricingData: formattedLicensePricingDataType;
  didInitialLicensePricingDataApiCallFail: boolean;
  defaultPaymentMethodDoesNotExist: boolean;
}

export const LicenseQuantity = ({
  quantity,
  setQuantity,
  formattedLicensePricingData,
  didInitialLicensePricingDataApiCallFail,
  defaultPaymentMethodDoesNotExist,
}: ILicenseQuantity) => {
  const {
    licensesState: { purchaseLicenseAssignment },
  } = useContext(LicensesContext);

  const licenseName = purchaseLicenseAssignment?.name;
  const licenseDisplayName = licenseName.includes('NUC-')
    ? purchaseLicenseAssignment?.license_definition?.description ??
      purchaseLicenseAssignment?.licenseDefinition?.description
    : licenseName;

  const onQuantityFieldInput = (event): void => {
    const input = event.target.value;
    if (input === '') {
      setQuantity('');
      return;
    }
    const inputNumber = Number(input);
    if (!Number.isNaN(inputNumber) && inputNumber >= 0 && inputNumber <= 99) {
      setQuantity(`${inputNumber}`);
    }
  };

  return (
    <StyledLicenseAmountContainer>
      <StyledFlexItem>
        <StyledBoxIconContainer>
          <StyledBoxIcon icon={Icons.boxOpenFull} />
        </StyledBoxIconContainer>
        <StyledLicenseNameText>{licenseDisplayName}</StyledLicenseNameText>
      </StyledFlexItem>
      <StyledFlexItem>
        <StyledQuantityField
          onChange={onQuantityFieldInput}
          value={quantity}
          data-testid="PlatformAdminUI-PurchaseLicenseModal-QuantityInput"
          inputProps={{ style: { fontWeight: 800, fontSize: '14px' } }}
          disabled={
            didInitialLicensePricingDataApiCallFail ||
            defaultPaymentMethodDoesNotExist
          }
        />
        <StyledXText>x</StyledXText>
        <StyledPriceText>
          {didInitialLicensePricingDataApiCallFail
            ? '$--'
            : formattedLicensePricingData?.licensePrice}
        </StyledPriceText>
        <IconButton
          onClick={() => setQuantity('0')}
          aria-label="Delete"
          data-testid="PlatformAdminUI-PurchaseLicenseModal-TrashButton"
          disabled={
            didInitialLicensePricingDataApiCallFail ||
            defaultPaymentMethodDoesNotExist
          }
        >
          <StyledTrashIcon icon={Icons.delete} />
        </IconButton>
      </StyledFlexItem>
    </StyledLicenseAmountContainer>
  );
};
